"use client";

import { ChartOptions } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar } from "react-chartjs-2";
import { RiskLevel } from "@portal/types/robot/IRobotEnums";
import { chartJsTextColor } from "@portal/helpers/chartJs";
import { expectedYield, optimisticYield, pessimisticYield } from "./AgreementDetailsData";

interface Props {
  riskLevel: RiskLevel;
}

/**
 * Chart.js version of the agreement details expected yield column chart.
 * @param interface
 * @returns a chart.
 */
export const AgreementDetailsChart = ({ riskLevel }: Props) => {
  const values = [pessimisticYield(riskLevel), expectedYield(riskLevel), optimisticYield(riskLevel)];
  const colors = ["#ff6a00", "#5900ff", "#5900ff"];

  const options: ChartOptions<"bar"> = {
    responsive: true,
    maintainAspectRatio: false,
    layout: { padding: { top: 24, bottom: 24 } },
    scales: {
      x: { ticks: { color: chartJsTextColor(), padding: 20 }, grid: { display: false } },
      y: {
        display: true,
        ticks: { display: false },
        border: { display: false },
        grid: { color: ctx => (ctx.tick.value === 0 ? chartJsTextColor() : "transparent") },
      },
    },
    plugins: {
      legend: { display: false },
      tooltip: { callbacks: { label: item => `${(item.raw as number).toFixed(1)}%` } },
      datalabels: {
        color: chartJsTextColor(),
        anchor: ctx => ((ctx.dataset.data[ctx.dataIndex] as number) >= 0 ? "end" : "start"),
        align: ctx => ((ctx.dataset.data[ctx.dataIndex] as number) >= 0 ? "top" : "bottom"),
        formatter: (value: number) => `${value.toFixed(1)}%`,
      },
    },
  };

  return (
    <div className="h-96">
      <Bar
        data={{
          labels: ["Dårlig", "Forventet", "Bra"],
          datasets: [{ data: values, backgroundColor: colors, borderWidth: 0 }],
        }}
        options={options}
        plugins={[ChartDataLabels]}
      />
    </div>
  );
};
